import { ApiResourceBaseClass as t } from "./baseApiCalls.js";
const o = "scopes";
class p extends t {
  /**
   * Retrieves the scopes available on Google/Facebook and Instagram for the given businesses
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/scopes`
   *
   * @param {GetScopesParams} queryParams - The business modal filters to select the businesses to query and the list of providers to check
   * @returns {Promise<GetScopesResponse>} A promise resolving to the data containing the scopes available
   */
  getScopes = async (s) => {
    const { data: e } = await this.get(`${o}`, s);
    return e;
  };
}
export {
  p as Scopes
};
